<template lang="pug">
    d2-container()
        el-form(:inline='true', :model='dataForm' size="mini" label-position='left' label-width="75px" label-suffix=':' )
            el-row(:span='24')
              el-col(:md='6' :sm="12")
                el-form-item(label='账号' )
                    el-input.inputWidth(v-model='dataForm.mobile' clearable='')
              el-col(:md='6' :sm="12")
                el-form-item(label='姓名')
                    el-input.inputWidth(v-model='dataForm.name' clearable='')
              el-col(:md='6' :sm="12")
                el-form-item(label='身份证')
                    el-input.inputWidth(v-model='dataForm.idCard' clearable='')
              el-col(:md='6' :sm="12")
                el-form-item(label='性别' )
                  el-select.inputWidth(v-model='dataForm.gender',placeholder='请选择',clearable )
                      el-option(label='男',value="0")
                      el-option(label='女',value="1")
            el-row(:span='24')
              el-col(:md='6' :sm="12")
                el-form-item(label='主办方')
                    el-select.inputWidth(v-model="dataForm.orgId" placeholder="请选择" filterable clearable)
                        el-option(v-for="(item,index) in sysOrgList" :key="index" :label="item.name" :value="item.orgId")
              el-col(:md='6' :sm="12")
                el-form-item(label='会员类别')
                    el-select.inputWidth(v-model='dataForm.type',placeholder='请选择',clearable)
                        el-option(label='注册会员',value="1")
                        el-option(label='初始会员',value="2")
                        el-option(label='荣誉会员',value="3")
              el-col(:md='6' :sm="12")
                el-form-item(label='会员级别')
                    el-select.inputWidth(v-model='dataForm.level',placeholder='请选择',clearable)
                        el-option(label="0.0" value="0.0")
                        el-option(label="1.0" value="1.0")
                        el-option(label="1.5" value="1.5")
                        el-option(label="2.0" value="2.0")
                        el-option(label="2.5" value="2.5")
                        el-option(label="3.0" value="3.0")
                        el-option(label="3.5" value="3.5")
                        el-option(label="4.0" value="4.0")
                        el-option(label="4.5" value="4.5")
                        el-option(label="5.0" value="5.0")
              el-col(:md='6' :sm="12")
                el-form-item(label='总积分')
                  el-input-number( v-model='dataForm.startScore',:min='startScoreMin',:max='StartScoreMax',@change='startChange',style='width:90px;')
                  font &nbsp;至&nbsp;
                  el-input-number(v-model='dataForm.endScore',:min='endScoreMin' @change='endChange',style='width:90px;',)
            el-row(:span='24')
              el-col(:md='6' :sm="12")
                el-form-item(label='账户属性' prop="accountType")
                    el-select.inputWidth(v-model="dataForm.accountType" placeholder="请选择")
                        el-option(label='全部',value="")                    
                        el-option(label='一般账户',:value="0")
                        el-option(label='青少年账户',:value="1")
        el-row(style="padding-bottom:15px;")
          el-col(:span="24")
            el-button(v-if="isAuth('mb:member:add')" @click='addOrUpdateHandle()',type='primary') 新增会员
            //- el-button(@click='updateLevel()',type='primary',:disabled='dataListSelections.length <= 0') 级别调整
            //- el-button(@click='updateGame()',type='success',:disabled='dataListSelections.length <= 0') 禁赛禁训
            el-button(v-if="isAuth('mb:member:download')" @click='exportExcel()',type='primary') 导出列表
            el-button(@click='queryList()',type='primary',icon='el-icon-search',style='float:right;') 查 询
            el-button(@click='cancellationList()',type='info',style='float:right;',v-if='menuFlag=== 1') 已注销会员
            el-button(@click='backList()',type='success',style='float:right;',v-if='menuFlag === 2') 会员列表
        //- ！！！！！！！！！！
        el-table(:data="tableData" id="out-table" style="width: 100%" , @selection-change='selectionChangeHandle' v-loading='dataListLoading' border)
            //- el-table-column(type='selection', header-align='center', align='center', width='50')
            el-table-column(prop='name',header-align='center',align='center',label='姓名')
            el-table-column(prop='mobile',header-align='center',align='center',label='会员账号')
            el-table-column(prop='idCard',header-align='center',align='center',label='身份证')
            el-table-column(prop='type',header-align='center',align='center',label='会员类别')
               template(slot-scope='scope')
                   font(v-if='scope.row.type === 1') 注册会员
                   font(v-if='scope.row.type === 2') 初始会员
                   font(v-if='scope.row.type === 3') 荣誉会员
            el-table-column(prop='gender',header-align='center',align='center',label='性别')
               template(slot-scope="scope")
                   span(v-if='scope.row.gender === 0') 男
                   span(v-if='scope.row.gender === 1') 女
            el-table-column(prop='level',header-align='center',align='center',label='级别' width="60")
            el-table-column(prop='scoreNum',header-align='center',align='center',label='总积分' width="70")
            el-table-column(prop='yearScore',header-align='center',align='center',label='年度积分' width="80")
            el-table-column(prop='gameNum',header-align='center',align='center',label='参赛次数')
            el-table-column(prop='trainCount',header-align='center',align='center',label='参训次数')
            el-table-column(prop='argueNum',header-align='center',align='center',label='争议次数')
            el-table-column(prop='accountType',header-align='center',align='center',label='账户属性')
               template(slot-scope="scope")
                   span(v-if='scope.row.accountType === 0') 一般账户
                   span(v-if='scope.row.accountType === 1') 青少年账户           
            el-table-column(prop='banStatus',header-align='center',align='center',label='状态')
               template(slot-scope="scope")
                   span(v-if='scope.row.banStatus == 0')
                     span.success()
                     span() &nbsp; 正常
                   span(v-if='scope.row.banStatus == 1')
                     span.warning()
                     span() &nbsp; 禁赛
                   span(v-if='scope.row.banStatus == 2')
                     span.warning()
                     span() &nbsp; 禁训
                   span(v-if='scope.row.banStatus == 3')
                     span.danger()
                     span() &nbsp; 禁赛/禁训
            el-table-column(prop='',header-align='center',align='center',label='操作')
                    template(slot-scope="scope")
                      el-menu.menuPonit(:collapse="isCollapse")
                        el-submenu(index="1")
                            template(slot="title")
                                i(class="el-icon-more" style='color:#02B90D;')
                            el-menu-item-group()
                                el-menu-item(v-if="isAuth('mb:member:detail')" :style="{display:menuFlag === 1?'block':'none'}" index="1-1" @click="viewHandle(scope.row.id)") 查看基本信息
                                el-menu-item(v-if="isAuth('mb:member:update')" :style="{display:menuFlag === 1?'block':'none'}" index="1-2" @click="addOrUpdateHandle(scope.row.id)") 修改
                                el-menu-item(v-if="isAuth('mb:member:gameList')" :style="{display:menuFlag === 1?'block':'none'}" index="1-3" @click='gameListHandle(scope.row.id)') 比赛记录
                                el-menu-item(v-if="isAuth('mb:member:updateLevel')" :style="{display:menuFlag === 1?'block':'none'}" index="1-4" @click='updateLevel(scope.row)') 调整级别
                                el-menu-item(v-if="isAuth('mb:member:ban')" :style="{display:menuFlag === 1?'block':'none'}" index="1-5" @click='updateGame(scope.row.id)') 禁赛禁训
                                el-menu-item(v-if="isAuth('mb:member:argue')" :style="{display:menuFlag === 1?'block':'none'}" index="1-6" @click='argueHandle(scope.row.id)') 查看争议记录
                                el-menu-item(v-if="isAuth('mb:member:org')" :style="{display:menuFlag === 1?'block':'none'}" index="1-7" @click='updateOrg(scope.row.id)') 归属设置
                                el-menu-item(v-if="isAuth('mb:member:downgrade')" :style="{display:menuFlag === 1?'block':'none'}" index="1-8" @click='downgradeRecorde(scope.row.id)') 升降级记录
                                el-menu-item(v-if="isAuth('mb:member:train')" :style="{display:menuFlag === 1?'block':'none'}" index="1-9" @click='trainingRecord(scope.row.id)') 培训记录
                                el-menu-item(v-if="isAuth('mb:member:bind') && scope.row.accountType==0" :style="{display:menuFlag === 1?'block':'none'}" index="1-12" @click='accountBinding(scope.row.id,scope.row.accountType)') 绑定青少年
                                el-menu-item(v-if="isAuth('mb:member:bind') && scope.row.accountType==1" :style="{display:menuFlag === 1?'block':'none'}" index="1-13" @click='accountBinding(scope.row.id,scope.row.accountType)') 绑定家长
                                el-menu-item(v-if="isAuth('mb:member:logout')" :style="{display:menuFlag === 1?'block':'none'}" index="1-10" @click='cancellation(scope.row.id)') 注销
                                el-menu-item(v-if="isAuth('mb:member:restore')" :style="{display:menuFlag === 2?'block':'none'}" index="1-11" @click='recoveryCancell(scope.row.id)') 恢复,取消撤销状态
        el-pagination(@size-change='sizeChangeHandle', @current-change='currentChangeHandle', :current-page='pageIndex', :page-sizes='[10, 20, 50, 100]', :page-size='pageSize', :total='totalPage', layout='total, sizes, prev, pager, next, jumper')
        //新增-修改
        add-or-update(v-if='addOrUpdateVisible',ref='addOrUpdate',@refreshDataList='getDataList')
        view-info(v-if='viewVisible', ref='viewInfo', @refreshDataList='getDataList')
        //账户绑定
        relive-or-binding(v-if='accountBindingVisible', ref='accountBinding')
        // 升降级记录
        downgrade-recorde(v-if='downgradeVisible', ref='downgrade')
        // 培训记录
        TraningRecorde(v-if='trainVisible', ref='training' :sysOrgData="sysOrgList")
        el-dialog(title="级别调整" :visible.sync="dialogFormVisible"  width='30%' :modal-append-to-body='false'  :close-on-click-modal='false')
          el-form(:model="form", :rules="rules", ref="form" label-width="auto" style='margin:0 auto;')
            el-form-item(label="设置会员级别:" prop="level")
              el-select(v-model="form.level" placeholder="请选择" clearable)
                    el-option(label="0.0" value="0.0")
                    el-option(label="1.0" value="1.0")
                    el-option(label="1.5" value="1.5")
                    el-option(label="2.0" value="2.0")
                    el-option(label="2.5" value="2.5")
                    el-option(label="3.0" value="3.0")
                    el-option(label="3.5" value="3.5")
                    el-option(label="4.0" value="4.0")
                    el-option(label="4.5" value="4.5")
                    el-option(label="5.0" value="5.0")
            el-form-item(label="填写原因:" prop="reason")
              el-input(v-model.trim="form.reason" type="textarea" :rows=3 resize="none" maxlength="99" show-word-limit)
            el-row(style='margin-top:30px;')
              el-col(align='center')
                el-button(type="primary" @click="levelSubmit()") 确认
                el-button(@click="dialogFormVisible=false" style='margin-left:50px;') 取消
        el-dialog(title="禁赛禁训" :visible.sync="banVisible" :modal-append-to-body='false')
          el-form(:model="gameForm" ref="gameForm")
            el-form-item(label="禁赛禁训设置:")

            el-row()
              el-col(:span='24')
                el-radio-group(v-model="gameForm.suspendType")
                  el-radio(:label="'1'" @click.native.prevent="clickSuspend('1')") 禁赛
                  el-date-picker( style='width:300px;'  v-model='suspendTime' range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd")
              el-col(:span='24')
                el-radio-group(v-model="gameForm.trainType" style='margin:15px 0px 15px 0px;')
                  el-radio(:label="'2'" @click.native.prevent="clicktrain('2')") 禁训
                  el-date-picker( style='width:300px;'  v-model='trainTime' range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd")

            el-form-item(label='原因说明:', prop='reason')
                el-input(type="textarea" :rows="5" resize="none" v-model="gameForm.reason" )
            el-row
              el-col(:span='24' align='center')
                el-button(type="primary" @click="gameSubmit()") 确认
                el-button(@click="banVisible=false" style='margin-left:40px;') 取消
        el-dialog(title="争议记录" :visible.sync="argueVisible" width="80%" :append-to-body="true" :modal-append-to-body='false'  :close-on-click-modal='false')
          //- 旧界面
          //- el-table(:data="argueData" border style="width:100%")
          //-   el-table-column(property="matchName" label="比赛名称" width="150" header-align='center',align='center')
          //-   el-table-column(property="matchId" label="比赛ID" width="150" header-align='center',align='center')
          //-   el-table-column(property="matchStartTime" label="比赛日期" width="150" header-align='center',align='center')
          //-   el-table-column(property="argue" label="争议记录" header-align='center',align='center')
            //- add新界面,待接入接口调试
          el-form(:inline='true', :model='coachList'  size='mini' label-position='right' label-width='75px' label-suffix=':')
              el-row(:span='24')
                el-col(:md='4' :sm='8')
                  el-form-item(label='姓名')
                      font {{coachList.name}}
                el-col(:md='6' :sm='8')
                  el-form-item(label='账号')
                      font {{coachList.account}}
                el-col(:md='7' :sm='8')
                  el-form-item(label='身份证件' label-position='right')
                      font {{coachList.sfzNumber}}
                el-col(:md='3' :sm='8')
                  el-form-item(label='性别' label-position='right')
                      font {{coachList.gender===0?'男':coachList.gender===1?'女':''}}
                el-col(:md='3' :sm='8')
                  el-form-item(label='总场次' label-position='right')
                      font {{coachList.allCount}}
              el-row(:span='24')

                el-col(:md='4' :sm='8')
                  el-form-item(label='总积分' label-position='right')
                      font {{coachList.allScore}}
                el-col(:md='6' :sm='8')
                  el-form-item(label='年度积分' label-position='right')
                      font {{coachList.yearScore}}
                el-col(:md='7' :sm='8')
                  el-form-item(label='季度积分' label-position='right')
                      font {{coachList.quarterlyScore}}
          el-table(:data="argueData" border style="width:100%")
            el-table-column(property="debateTime" label="争议时间"  header-align='center',align='center')
            el-table-column(property="uploadName" label="上传争议用户姓名"  header-align='center',align='center')
            el-table-column(property="matchName" label="比赛名称" header-align='center',align='center')
            el-table-column(property="argue" label="操作" header-align='center',align='center')
                template(slot-scope="scope")
                      <el-button type="text" @click="viewArgue(scope.row,'view')">查看详情</el-button>
                      <el-button type="text" @click="viewArgue(scope.row,'edit')">修改</el-button>
                      <el-button type="text" style="color:red" @click="deleteArgue(scope.row.debateId)">删除</el-button>
          el-pagination(@size-change='sizeChangeHandle2', @current-change='currentChangeHandle2', :current-page='pageIndex2', :page-sizes='[10, 20, 30]', :page-size='pageSize2', :total='totalPage2', layout='total, sizes, prev, pager, next, jumper')
          el-row(style='padding-top:30px;')
            el-col(:span='24')
              el-button(@click="argueVisible=false" type='primary' style='float:right') 返回
          // 查看或者修改争议
          view-update-argue(v-if='argueDetailVisible', ref='viewArgue')
        el-dialog(title="归属设置" :visible.sync='senseVisible' width="80%" :modal-append-to-body='false'  :close-on-click-modal='false')
                el-row
                   el-col(:span="11")
                      el-card(shadow="never")
                        div(slot="header" )
                          el-row(style='display: flex;')
                            el-input(v-model='orgName' clearable='')
                            el-button(@click="getDataList1" icon='el-icon-search' style='margin-left: 10px;') 会员列表
                            el-button(@click="getDataList1" icon='el-icon-search') 查询
                        div
                          el-table(:data="leftData" border v-loading='memberOrgListLoading' @selection-change="checkAll" max-height="400")
                              el-table-column(type="selection" align='center')
                              el-table-column(prop="name" label="主办方" align='center')
                              el-table-column(prop="proviceName" label="省" align='center')
                              el-table-column(prop="cityName" label="市" align='center')
                          el-pagination(@size-change='sizeChangeHandle1', @current-change='currentChangeHandle1', :current-page='pageIndex1', :page-sizes='[10, 20, 50, 100]', :page-size='pageSize1', :total='totalPage1', layout='total, sizes, prev, pager, next, jumper')
                   el-col(:span="2" align='center')
                      div.opSetting
                          div(@click="handelSelect")
                              el-button(style='padding:10px' icon="el-icon-d-arrow-right" :disabled="nowSelectData.length ? false:true" type="primary") 添加
                          div.spacing(@click="handleRemoveSelect" style='margin-top:10px;')
                              el-button(style='padding:10px' icon="el-icon-d-arrow-left" :disabled="nowSelectRightData.length ? false:true" type="danger") 删除
                   el-col(:span="11")
                        el-card(shadow="never")
                            div(slot="header")
                                font.font_label 已添加的归属主办方
                            div
                                el-table(:data="rightData" border @selection-change="checkRightAll" max-height="400")
                                    el-table-column(type="selection" :selectable="selectable" align='center')
                                    el-table-column(prop="name" label="主办方" align='center')
                                    el-table-column(prop="proviceName" label="省" align='center')
                                    el-table-column(prop="cityName" label="市" align='center')
                span.dialog-footer(slot="footer")
                    el-button(@click="addEnroll" type="primary") 确 定
                    el-button(@click="senseVisible=false") 取 消
</template>

<script>
import table from './table.js'
import AddOrUpdate from './add-or-update'
import ViewInfo from './view-info'
import DowngradeRecorde from './downgrade-recorde'
import TraningRecorde from './traning-recorde'
import ViewUpdateArgue from './view-update-argue'
import ReliveOrBinding from './relive-or-binding.vue';
export default {
  name: 'mb-member',
  data () {
    return {
      codeType: 0,
      menuFlag: 1,
      coachList: {
        sex: 1
      },
      table: {
        columns: table.columns,
        data: null,
        size: 'mini',
        stripe: true,
        border: true
      },
      isCollapse: true,
      dataForm: {
        name: '',
        mobile: '',
        idCard: '',
        orgId: '',
        gender: '',
        type: '',
        level: '',
        startScore: '',
        endScore: '',
        accountType:"",
      },
      orgName: '',
      gameForm: {
        id: '',
        suspendType: '',
        trainType: '',
        suspendStartTime: '',
        suspendEndTime: '',
        trainStartTime: '',
        trainEndTime: '',
        reason: ''
      },
      suspendTime: new Array(),
      trainTime: new Array(),
      mbId: '',
      form: {
        level: '',
        reason: ''
      },
      rules: {
        level: [
          { required: true, message: '会员级别不能为空!', trigger: 'blur' }
        ],
        reason: [
          { required: true, message: '原因不能为空!', trigger: 'blur' }
        ]
      },
      ids: new Array(),
      tableData: [],
      rightData: [],
      leftData: [],
      argueData: [],
      nowSelectData: [], // 左边选中列表数据
      nowSelectRightData: [], // 右边选中列表数据
      dataListSelections: [],
      sysOrgList: [],
      pageIndex: 1,
      pageIndex1: 1,
      pageIndex2: 1,
      pageSize: 10,
      pageSize1: 10,
      pageSize2: 10,
      totalPage: 0,
      totalPage1: 0,
      totalPage2: 0,
      dataListLoading: false,
      memberOrgListLoading: false,
      startScoreMin: undefined,
      StartScoreMax: undefined,
      endScoreMin: undefined,
      addOrUpdateVisible: false,
      viewVisible: false,
      dialogFormVisible: false,
      banVisible: false,
      argueVisible: false,
      senseVisible: false,
      mbBelongList: [],
      orgIdList: [],
      argueHandleID: '',
      exportDatas: [], //导出数据
      downgradeVisible: false, // 升降级记录
      trainVisible: false, // 培训记录
      argueDetailVisible: false, // 争议操作
      accountBindingVisible:false
    }
  },
  components: {
    AddOrUpdate,
    ViewInfo,
    DowngradeRecorde,
    TraningRecorde,
    ViewUpdateArgue,
    ReliveOrBinding
  },
  created () {
    this.getDataList()
    this.changeOrg()
  },
  methods: {
    queryList(){
       this.pageIndex=1
       this.getDataList()
    },
    // 获取争议详情
    disputeInfo (id) {
      this.coachList = {}
      this.$http({
        url: this.$http.adornUrl('/mbMember/getDebateInfoByMemberId/' + id),
        method: 'get'
      }).then((data) => {
        if (data && data.code === 0) {
          this.coachList = data.data
        } else {
        }
      })
    },
    // 查看或者修改争议
    viewArgue (row, oprType) {
      this.argueDetailVisible = true
      this.$nextTick(() => {
        this.$refs.viewArgue.init(row, oprType)
      })
    },
    // 删除争议 待接入
    deleteArgue (id) {
      this.$confirm('是否删除争议记录', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          this.$http({
            url: this.$http.adornUrl(`/mbMember/deleteDebateById/` + id),
            method: 'get'
          }).then((data) => {
            if (data && data.code === 0) {
              this.argueHandle(this.argueHandleID)
              this.$message.success('操作成功')
            }
          })
        })
        .catch(() => {
          this.$message.info('操作取消')
        })
    },
    argueHandle (id) {
      this.argueHandleID = id
      this.argueVisible = true
      this.argueData = []
      this.disputeInfo(id)
      this.$http({
        url: this.$http.adornUrl(`/mbMember/getDebateListByMemberId/${id}`),
        method: 'get',
        params: this.$http.adornParams({ page: this.pageIndex2,
          limit: this.pageSize2 })
      }).then((data) => {
        if (data && data.code === 0) {
          console.log(data.data)
          this.argueData = data.data.rows
          this.totalPage2 = data.data.total
        } else {
          this.argueData = []
          this.totalPage2 = 0
        }
      })
    },
    // 升降级记录
    downgradeRecorde (id) {
      this.downgradeVisible = true
      this.$nextTick(() => {
        this.$refs.downgrade.init(id)
      })
    },
    // 培训记录
    trainingRecord (id) {
      this.trainVisible = true
      this.$nextTick(() => {
        this.$refs.training.init(id)
      })
    },
    //账户绑定
    accountBinding (id,accountType) {
      this.accountBindingVisible = true
      this.$nextTick(() => {
        this.$refs.accountBinding.init(id,accountType)
      })
    },
    //注销会员
    cancellation (id) {
      // console.log(id);
      this.$http({
            url: this.$http.adornUrl(
              '/mbMember/logoutMember'
            ),
            method: 'post',
            data: {
              mbId: id
            }
          }).then(data => {
            console.log(data)
            if (data && data.code === 0) {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500
              })
              this.getDataList()
            } else {
              this.$message.error(data.msg)
            }
          })
    },
    //已注销会员列表
    cancellationList () {
      this.menuFlag = 2
      this.codeType = 1
      this.getDataList()
    },
    //恢复已注销的会员
    recoveryCancell (id) {
      this.$http({
            url: this.$http.adornUrl(
              '/mbMember/recoveryMember'
            ),
            method: 'post',
            data: {
               mbId: id
            }
          }).then(data => {
            console.log(data)
            if (data && data.code === 0) {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500
              })
              this.getDataList()
            } else {
              this.$message.error(data.msg)
            }
          })
    },
    //返回列表
    backList () {
      this.menuFlag = 1
      this.codeType = 0
      this.getDataList()
    },
    //新增按钮事件
    addOrUpdateHandle (id) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id)
      })
    },
    // 导出
    exportExcel () {
      this.$http({
        url: this.$http.adornUrl('/mbMember/exportList'),
        method: 'post',
        data: {
          name: this.dataForm.name,
          mobile: this.dataForm.mobile,
          idCard: this.dataForm.idCard,
          orgId: this.dataForm.orgId,
          gender: this.dataForm.gender,
          type: this.dataForm.type,
          level: this.dataForm.level,
          startScore: this.dataForm.startScore,
          endScore: this.dataForm.endScore
        }
      })
        .then((data) => {
          console.log('会员列表信息：', data)
          if (data && data.code === 0) {
            console.log(data.list)
            if (data.list == null || data.list.length === 0) {
              this.$message.info('没有要导出的数据!')
              return
            }
            let exportData = data.list
            exportData.forEach((i) => {
              i.type = { 1: '注册会员', 2: '初始会员', 3: '荣誉会员' }[i.type]
              i.gender = { 0: '男', 1: '女' }[i.gender]
              i.byx1 = { 0: '正常', 1: '禁赛', 2: '禁训', 3: '禁赛/禁训' }[i.byx1]
            })
            console.log('导出的订单数据：', exportData)
            this.$export
              .excel({
                columns: this.table.columns,
                data: exportData,
                title: '会员信息'
              })
              .then(() => {
                this.$message.success('导出表格成功')
              })
          }
        })
        .catch((e) => {
          this.$message.success('数据太多，请筛选后导出')
        })
    },
    selectable (row, index) {
      if (row.name == '国奥利贤') {
        return false
      } else {
        return true
      }
    },
    getDataList1 () {
      this.memberOrgListLoading = true
      console.log(this.rightData)
      this.rightData.forEach((data) => {
        this.orgIdList.push(data.id)
      })
      this.$http({
        url: this.$http.adornUrl('/sysOrg/orgList'),
        method: 'get',
        params: this.$http.adornParams({
          page: this.pageIndex1,
          limit: this.pageSize1,
          name: this.orgName,
          orgIdList: JSON.stringify(this.orgIdList)
        })
      }).then((data) => {
        if (data && data.code === 0) {
          this.leftData = data.page.records
          this.totalPage1 = data.page.total
        } else {
          this.leftData = []
          this.totalPage1 = 0
        }
        this.memberOrgListLoading = false
      })
    },
    updateOrg (id) {
      this.mbId = id
      this.senseVisible = true
      this.$http({
        url: this.$http.adornUrl('/sysOrg/getBelognList'),
        method: 'get',
        params: this.$http.adornParams({
          page: this.pageIndex1,
          limit: this.pageSize1,
          mbId: this.mbId
        })
      }).then((data) => {
        if (data && data.code === 0) {
          this.leftData = data.page.records
          this.rightData = data.list
          this.totalPage1 = data.page.total
        } else {
          this.leftData = []
          this.totalPage1 = 0
        }
      })
    },
    checkAll (val) {
      this.nowSelectData = val
    },
    checkRightAll (val) {
      this.nowSelectRightData = val
    },
    // 选中
    handelSelect () {
      this.rightData = this.handleConcatArr(this.rightData, this.nowSelectData)
      this.handleRemoveTabList(this.nowSelectData, this.leftData)
      this.nowSelectData = []
    },
    // 取消
    handleRemoveSelect () {
      this.leftData = this.handleConcatArr(
        this.leftData,
        this.nowSelectRightData
      )
      this.handleRemoveTabList(this.nowSelectRightData, this.rightData)
      this.nowSelectRightData = []
    },
    handleConcatArr (rightData, nowSelectData) {
      let arr = []
      arr = arr.concat(rightData, nowSelectData)
      return arr
    },
    handleRemoveTabList (isNeedArr, originalArr) {
      if (isNeedArr.length && originalArr.length) {
        for (let i = 0; i < isNeedArr.length; i++) {
          for (let k = 0; k < originalArr.length; k++) {
            if (isNeedArr[i]['name'] === originalArr[k]['name']) {
              originalArr.splice(k, 1)
            }
          }
        }
      }
    },
    //添加主办方入库
    addEnroll () {
      console.log(this.rightData)
      this.mbBelongList = []
      this.rightData.forEach((data) => {
        this.mbBelongList.push({
          orgId: data.id,
          orgName: data.name,
          mbId: this.mbId
        })
      })
      this.$http({
        url: this.$http.adornUrl(`/mbBelongOrg/save`),
        method: 'post',
        data: this.mbBelongList
      }).then((data) => {
        console.log(data)
        if (data && data.code === 0) {
          this.$message.success('添加成功!')
          this.senseVisible = false
        }
      })
    },
    clickSuspend (e) {
      this.gameForm.suspendType = e
      // e == this.gameForm.suspendType
      //   ? (this.gameForm.suspendType = "")
      //   : (this.gameForm.suspendType = e);
    },
    clicktrain (e) {
      this.gameForm.trainType = e
      // e == this.gameForm.trainType
      //   ? (this.gameForm.trainType = "")
      //   : (this.gameForm.trainType = e);
    },
    gameSubmit () {
      if (this.suspendTime && this.suspendTime.length > 0) {
        this.gameForm.suspendStartTime = this.suspendTime[0]
        this.gameForm.suspendEndTime = this.suspendTime[1]
      } else {
        this.gameForm.suspendStartTime = undefined
        this.gameForm.suspendEndTime = undefined
      }
      if (this.trainTime && this.trainTime.length > 0) {
        this.gameForm.trainStartTime = this.trainTime[0]
        this.gameForm.trainEndTime = this.trainTime[1]
      } else {
        this.gameForm.trainStartTime = undefined
        this.gameForm.trainEndTime = undefined
      }
      this.$http({
        url: this.$http.adornUrl('/mbBan/save'),
        method: 'post',
        data: {
          suspendType: this.gameForm.suspendType,
          trainType: this.gameForm.trainType,
          suspendStartTime: this.gameForm.suspendStartTime,
          suspendEndTime: this.gameForm.suspendEndTime,
          trainStartTime: this.gameForm.trainStartTime,
          trainEndTime: this.gameForm.trainEndTime,
          reason: this.gameForm.reason,
          mbId: this.mbId
        }
      }).then((data) => {
        if (data && data.code === 0) {
          this.$message({
            message: '操作成功',
            type: 'success',
            duration: 1500,
            onClose: () => {
              this.banVisible = false
              this.getDataList()
            }
          })
        }
      })
    },
    levelSubmit () {
      console.log(this.ids.toString())
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.$http({
            url: this.$http.adornUrl(`/mbMember/levelUpdate`),
            method: 'get',
            params: this.$http.adornParams({
              // ids: JSON.stringify(this.ids),
              ids: this.ids.toString(),
              level: this.form.level,
              reason: this.form.reason
            })
          }).then((data) => {
            if (data && data.code === 0) {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.dialogFormVisible = false
                  this.getDataList()
                }
              })
            }
          })
        }
      })
    },
    viewHandle (id) {
      this.viewVisible = true
      this.$nextTick(() => {
        this.$refs.viewInfo.init1(id)
      })
    },
    gameListHandle (id) {
      this.$router.push({
        path: './game',
        query: { mbId: id }
      })
    },
    // 多选
    selectionChangeHandle (val) {
      this.dataListSelections = val
    },
    //修改等级事件
    updateLevel (item) {
      this.ids = []
      if (item) {
        this.ids.push(item.id)
        this.form.level = item.level
      } else {
        for (let i of this.dataListSelections) {
          this.ids.push(i.id)
        }
        this.form.level = ''
      }
      // var ids = id ? [id] : this.dataListSelections.map(item => {
      //     return item.id
      // })
      // this.ids = ids
      this.dialogFormVisible = true
    },
    updateGame (id) {
      this.mbId = id
      // this.ids = []
      // for(let i of this.dataListSelections){
      //   this.ids.push(i.id)
      // }
      // var ids = id ? [id] : this.dataListSelections.map(item => {
      //     return item.id
      // })
      // this.ids = ids
      this.suspendTime = new Array()
      this.trainTime = new Array()
      this.$http({
        url: this.$http.adornUrl(`/mbBan/getByMbId/${this.mbId}`),
        method: 'get',
        params: this.$http.adornParams()
      }).then((data) => {
        this.gameForm = data.bean
        if (data.bean.suspendStartTime && data.bean.suspendEndTime) {
          this.suspendTime.push(data.bean.suspendStartTime)
          this.suspendTime.push(data.bean.suspendEndTime)
        }
        if (data.bean.trainStartTime && data.bean.trainEndTime) {
          this.trainTime.push(data.bean.trainStartTime)
          this.trainTime.push(data.bean.trainEndTime)
        }
      })
      this.banVisible = true
    },

    getDataList () {
      this.dataListLoading = true
      this.$http({
        url: this.$http.adornUrl('/mbMember/list'),
        method: 'post',
        data: {
          page: this.pageIndex,
          rows: this.pageSize,
          name: this.dataForm.name,
          mobile: this.dataForm.mobile,
          idCard: this.dataForm.idCard,
          orgId: this.dataForm.orgId,
          gender: this.dataForm.gender,
          type: this.dataForm.type,
          level: this.dataForm.level,
          startScore: this.dataForm.startScore,
          endScore: this.dataForm.endScore,
          deleted: this.codeType,
          accountType:this.dataForm.accountType
        }
      }).then((data) => {
        console.log(data)
        if (data && data.code === 0) {
          this.tableData = data.list.rows
          this.totalPage = data.list.total
        } else {
          this.tableData = []
          this.totalPage = 0
        }
        this.dataListLoading = false
      })
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    sizeChangeHandle1 (val) {
      this.pageSize1 = val
      this.pageIndex1 = 1
      this.getDataList1()
    },
    sizeChangeHandle2 (val) {
      this.pageSize2 = val
      this.pageIndex2 = 1
      this.argueHandle(this.argueHandleID)
    },
    changeOrg () {
      this.$http({
        url: this.$http.adornUrl('/sysOrg/list'),
        method: 'get',
        params: this.$http.adornParams({
          cityId: '',
          proviceId: ''
        })
      }).then((data) => {
        this.sysOrgList = data && data.code === 0 ? data.list : []
      })
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getDataList()
    },
    currentChangeHandle1 (val) {
      this.pageIndex1 = val
      this.getDataList1()
    },
    currentChangeHandle2 (val) {
      this.pageIndex2 = val
      this.argueHandle(this.argueHandleID)
    },
    //查询条件总积分事件
    startChange (value) {
      this.endScoreMin = value
    },
    //查询条件总积分事件
    endChange (value) {
      this.StartScoreMax = value
    }
  }
}
</script>
<style>
/* 操作三点 菜单样式 */
@import '../../css/opr3dot.css';

.inputWidth {
  width: 200px;
}

.opSetting {
  text-align: center;
  margin-top: 30px;
}

.el-input-number--mini .el-input__inner {
  padding-left: 25px;
  padding-right: 25px;
}
.el-input-number--mini .el-input-number__decrease,
.el-input-number--mini .el-input-number__increase {
  width: 24px;
  font-size: 12px;
}
.el-form--inline .el-form-item {
  display: inline-block;
  margin-right: 0px;
  vertical-align: top;
}
/* 分页样式 */
.el-pager li {
  padding: 0 4px;
  font-size: 13px;
  min-width: 20.5px;
  height: 28px;
  line-height: 28px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;
}
</style>
